import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from '../../../notification/services';
import { AppFilter, CommonServices } from 'src/modules/shared';
import { debounceTime, takeUntil, distinctUntilChanged, tap, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-notifications-verification',
	templateUrl: './notification.component.html',
	styleUrls: [ './notification.component.scss' ]
})
export class VerificationComponent implements OnDestroy {
	private unsubscribe$: Subject<void> = new Subject<void>();
	public isOrganizationEmailVerified: boolean = true;
	public isEmailVerified: boolean = true;
	public organizationId: string;
	public verificationStatus: any;
	public organization: any;
	public user: any;
	public modulet: any;
	public showMessage: boolean = false;

	error;
	loading;
	success;

	constructor(private _searchsvc: NotificationService, private commonServices: CommonServices) {
		this.organizationId = window.localStorage.getItem('organizationId');
		this.user = JSON.parse(window.localStorage.getItem('user'));
		this.organization = JSON.parse(window.localStorage.getItem('organization'));
		this.isEmailVerified = this.user['emailVerified'];
		let role = this.organization.organizationTypeId.organizationTypeId;
		if (role === 'collaborator') {
			this.modulet = 'collaborator';
		} else if (role === 'contractor') {
			this.modulet = 'contractor';
			this.showMessage = true;
			this.isOrganizationEmailVerified = this.organization.jpaContractor['companyEmailVerified'];
			let ver = this.organization.jpaContractor['verificationStatus'];
			if (ver === 'NO_ACCESS') {
				this.getAccessTemplate();
			}
		} else if (role === 'system_collaborator' || role === 'system_admin') {
			this.modulet = 'admin';
		} else if (role === 'mda') {
			this.modulet = 'mda';
		} else if (role === 'guest_mda') {
			this.modulet = 'mda';
		} else {
			// console.log(role)
		}
	}

	getAccessTemplate() {
		this.commonServices.getTemplate({ messageTemplateId: 'NO_ACCESS_COMPANY_TEMPLATE' }).subscribe((res: any) => {
			this.verificationStatus = res.mailTemplate;
		});
	}
	resend() {
		this.error = null;
		this.loading = true;
		this.success = null;
		this._searchsvc
			.resendEmailConfirmation({ organizationId: this.organizationId, appUserId: this.user.appUserId, body: '' })
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(
				(res) => {
					this.loading = false;
					this.isEmailVerified = true;
					this.success = 'Email confirmation sent successfully';
				},
				(error) => {
					this.loading = false;
					this.error = error.error;
				}
			);
	}

	resendCompany() {
		this.error = null;
		this.loading = true;
		this.success = null;
		this._searchsvc
			.resendCompanyEmailConfirmation({ organizationId: this.organizationId, body: '' })
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(
				(res) => {
					this.loading = false;
					this.success = 'Email confirmation sent successfully';
					this.isOrganizationEmailVerified = true;
				},
				(error) => {
					this.loading = false;
					this.error = error.error;
				}
			);
	}

	ngOnDestroy() {
		// unsubscribe all subsciptons
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}
}
